export default __webpack_public_path__ + "static/media/Group_588.405f29c1.svg";